import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import BlogList from "./BlogList";
import { FaSpinner } from "react-icons/fa";

const BlogProp = ({ column, StyleVarProp, data }) => {
  const location = useLocation();

  // read query parameter
  const queryParams = new URLSearchParams(location.search);
  const category = queryParams.get("category"); // e.g. "Financial Health"

  const [visibleItems, setVisibleItems] = useState([]);
  const [dataVisibleCount, setDataVisibleCount] = useState(8);
  const dataIncrement = 8;
  const [noMorePost, setNoMorePost] = useState(false);

  // filter based on query param
  const filteredData =
    category && category.toLowerCase() !== "all"
      ? data.filter((item) =>
          item.categories.some(
            (cat) => cat.toLowerCase() === category.toLowerCase()
          )
        )
      : data;

  useEffect(() => {
    // reset pagination when category changes
    setDataVisibleCount(8);
    setNoMorePost(false);
  }, [category]);

  useEffect(() => {
    setVisibleItems(filteredData.slice(0, dataVisibleCount));
  }, [filteredData, dataVisibleCount]);

  const handleLoadmorebl = (e) => {
    e.preventDefault();
    const nextCount = dataVisibleCount + dataIncrement;
    if (nextCount >= filteredData.length) setNoMorePost(true);
    setDataVisibleCount(nextCount);
  };

  return (
    <>
      <div className="col-lg-12">
        <div className="row row--15">
          {visibleItems.length > 0 ? (
            visibleItems.map((item) => (
              <div key={item.id} className={column}>
                <BlogList StyleVar={StyleVarProp} data={item} />
              </div>
            ))
          ) : (
            <p className="text-center">No posts found in this category.</p>
          )}
        </div>
      </div>

      {visibleItems.length > 0 && (
        <div className="col-lg-12 text-center">
          <div className="rwt-load-more text-center mt--60">
            <button
              className="btn btn-default btn-icon"
              onClick={handleLoadmorebl}
              disabled={noMorePost}
            >
              {noMorePost ? (
                "No Post Here"
              ) : (
                <span>
                  View More Post <span className="icon"><FaSpinner /></span>
                </span>
              )}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default BlogProp;
